export const searchTooltipText = 'Search by error code and human-readable description';
export const searchPlaceholderText = 'Search by error code and ...';
export const editTooltipText = 'Edit this error code';

